<mat-toolbar class="content-header">
  <mat-icon class="header-icon" fontIcon="track_changes"></mat-icon>

  <h1 class="page-title">
    {{'trackers.allTrackers' | translate}}
  </h1>

  <span class="toolbar-spacer"></span>

  <div class="toolbar-menu">
    <lib-button (click)="editDevice()" color="primary" tooltip="{{'trackers.addTracker' | translate}}"
      icon="add"></lib-button>

    <lib-button (click)="editDevicesConfig()" *ngIf="canEditConfigs()" tooltip="{{'units.device.device_config' | translate}}" icon="settings"
      color="secondary"></lib-button>

    <lib-button [matMenuTriggerFor]="submenu" *ngIf="selectedDevices.length >= 1"
      text="{{'units.device.grouped_actions' | translate}}" icon="group" color="secondary"></lib-button>

    <mat-menu #submenu="matMenu">
      <button mat-menu-item (click)="setDevicesConfig()">
        {{'units.device.set_config' | translate}}
      </button>

      <button mat-menu-item (click)="setDevicesProject()">
        {{'units.device.set_project' | translate}}
      </button>

      <button mat-menu-item (click)="confirmDeleteTracker()">
        {{'trackers.delete_trackers' | translate}}
      </button>

      <button mat-menu-item (click)="mergeTrackers(selectedDevices)" *ngIf="canMerge">
        {{ 'units.device.merge_trackers' | translate }}
      </button>
    </mat-menu>

    <app-search-bar class="filter" (searchText)="search($event)"></app-search-bar>

    <mat-slide-toggle (change)="toggleMap($event)" class="map-title" [checked]="mapDisplayed">
      {{'viewer.maps' | translate}}
    </mat-slide-toggle>
  </div>

</mat-toolbar>

<div class="flex-auto">
  <div [ngClass]="{ 'full-width': !mapDisplayed }" class="devices-table table-container">
    <table mat-table [dataSource]="devicesData" matSort class="mat-elevation-z8">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-icon>check_box_outline_blank</mat-icon>
        </th>

        <td mat-cell *matCellDef="let row; let i = index">
          <mat-checkbox class="device-checkbox" [(ngModel)]="row.selected" [name]="'device-select-' + i"
            (change)="onRowSelected()"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="devices_other"></mat-icon>
            <span>Name</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <h4 class="device-name" (click)="editDevice(row)">
            {{ row.name.length > 61 ? (row.name | slice:0:57) + '...' : row.name }}
            <mat-icon *ngIf="row.hasLinkedInterventions" class="linked-intervention-icon" fontIcon="handyman"
              title="{{'resources.tracker_linked_interventions'|translate}}"></mat-icon>
          </h4>

          <span class="tracker-type">
            {{row.type}} | Last update: {{row.lastUpdate | timeFormat:"yyyy-MM-dd HH:mm"}}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="projects">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon>folder</mat-icon>
            <span>Project</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <ul>
            <li *ngFor="let project of row.projects" (click)="selectCurrentProject(project.id)"
              class="{{row.project && row.project.id == project.id ? 'active' : ''}} project-name">{{project.name}}
            </li>
          </ul>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon>signal_cellular_alt</mat-icon>
            <span>Status</span>
          </div>
        </th>

        <td mat-cell *matCellDef="let row">
          <div class="com-status">
            <div class="chip-list" *ngIf="row.status">
              <lib-chip *ngIf="row.status == 'active'" color="primary" icon="wifi" text="{{'status.active'|translate}}">
              </lib-chip>

              <lib-chip *ngIf="row.status == 'inactive'" color="warning" icon="wifi_off"
                text="{{'status.inactive'|translate}}">
              </lib-chip>

              <lib-chip *ngIf="row.batteryLevel > 20" color="primary" icon="battery_full" text="{{row.batteryLevel}}%">
              </lib-chip>

              <lib-chip *ngIf="row.batteryLevel <= 20 && row.batteryLevel >= 0" color="danger" icon="battery_alert"
                text="{{row.batteryLevel}}%">

              </lib-chip>

              <lib-chip *ngIf="row.batteryLevel== -1" icon="battery_unknown" text="{{'status.active'|translate}}">
              </lib-chip>

              <lib-chip *ngIf="row.shackleBattery > 20" color="primary" class="shackle-icon" svgIcon="shackle_full">
              </lib-chip>

              <lib-chip *ngIf="row.shackleBattery <= 20 && row.shackleBattery >= 0" color="danger" class="shackle-icon"
                svgIcon="shackle" text="{{row.shackleBattery}}%">
              </lib-chip>
            </div>

            <div class="chip-list" *ngIf="!row.status">
              <lib-chip color="warning" icon="wifi" text="{{'status.loading'|translate}}">
              </lib-chip>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            <mat-icon>settings</mat-icon>
            <span>Actions</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <lib-button color="none" textColor="secondary" icon="edit" (click)="editDevice(row)">
          </lib-button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="devicesColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: devicesColumns;"></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="devicesColumns.length">
          <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
          </lib-no-data>
        </td>
      </tr>
    </table>

    <mat-paginator #devicePaginator [length]="devicesCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"
      class="paginator" (page)="handlePageEvent($event)">
    </mat-paginator>

    <div *ngIf="loading" class="table-overlay">
      <app-spinner></app-spinner>
    </div>
  </div>

  <app-device-map [ngClass]="{ hidden: !mapDisplayed }" [trackers]="devices" [currentTrackers]="selectedDevices"
    [configs]="trackerConfigs">
  </app-device-map>
</div>